import React from 'react'
import ContactBody from './Components/ContactBody'
import IndexFooter from '../Index/Components/IndexFooter'
// import TopBar from '../ProjectComponents/TopBar'
import SEOHelmet from '../ProjectComponents/SEOHelmet'

function ContactPage() {
  const page = 'contact'
  return (
    <>
        {/* topbar */}
        <SEOHelmet page={page} />
        <div className='bg-findColleges contact main'>
          {/* <TopBar/> */}
          <ContactBody/>
        </div>

        {/* footer */}
        <IndexFooter/>
    </>
  )
}

export default ContactPage